export default "__VITE_ASSET__BInNLLJQ__"